import {Application} from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export {application}
Turbo.StreamActions.full_page_reload = function () {
    console.log("reload");
    location.reload();
}
// Turbo.StreamActions.caption_button_toggle = function () {
//     const elem = document.getElementById("capt_butt_"+this.target)
//     const rez = Stimulus.getControllerForElementAndIdentifier(elem,"paint_button")
//     console.log(elem)
//     console.log(rez)
//
// }


Turbo.StreamActions.highlite_success = function () {
    // console.log(this.target)
    let success_row = document.getElementById(this.target)
    // console.log(success_row)
    if (success_row) {
        success_row.classList.add("border")
        success_row.classList.remove("border-danger")
        success_row.classList.add("border-success")
        let flash_class = "animate-border-green-in"
        success_row.addEventListener('animationend', function (e) {
            e.target.classList.remove(flash_class);
        })
        success_row.classList.add(flash_class)
    }
}
Turbo.StreamActions.highlite_danger = function () {
    // console.log(this.innerHTML)
    let danger_row = document.getElementById(this.target)
    // console.log(danger_row)
    if (danger_row) {
        danger_row.classList.add("border")
        danger_row.classList.remove("border-success")
        danger_row.classList.add("border-danger")
        let flash_class = "animate-border-red-in"
        danger_row.addEventListener('animationend', function (e) {
            e.target.classList.remove(flash_class);
        })
        danger_row.classList.add(flash_class)
    }
}
